import "./widget.scss";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import { useState } from "react";
import { Link } from "react-router-dom";

const Widget = ({ type }) => {

  const [countUser, setCountUser] = useState('')
  const [countOrder, setCountOrder] = useState("")
  const [earnOrder, setEarnOrder] = useState("")
  const [countProducts,setCountProducts]=useState('')
  
  fetch("http://localhost:8000/users/count", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({}),
  })
    .then((response) => response.json())
    .then((data) => {
setCountUser(data)

    })
    .catch((error) => {
      console.error(error);
    });
  
  

fetch("http://localhost:8000/order/count", {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
  },
  body: JSON.stringify({}),
})
  .then((response) => response.json())
  .then((data) => {
    setCountOrder(data);
  })
  .catch((error) => {
    console.error(error);
  });

  fetch("http://localhost:8000/order/earn", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({}),
  })
    .then((response) => response.json())
    .then((data) => {
      setEarnOrder(data);
    })
    .catch((error) => {
      console.error(error);
    });
  
  
  fetch("http://localhost:8000/products/count", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({}),
  })
    .then((response) => response.json())
    .then((data) => {
      setCountProducts(data);
    })
    .catch((error) => {
      console.error(error);
    });

  let data;

  //temporary
  const diff = 10;

  switch (type) {
    case "user":
      data = {
        title: "USERS",
        isMoney: false,
        link: 'see all users',
        anchor:'/adminUsers',
        count:countUser,
        icon: (
          <PersonOutlinedIcon
            className="icon"
            style={{
              color: "crimson",
              backgroundColor: "rgba(255, 0, 0, 0.2)",
            }}
          />
        ),
      };
      break;
    case "order":
      data = {
        title: "ORDERS",
        isMoney: false,
        count: countOrder,
        anchor: "/orders",
        link: "View all orders",
        icon: (
          <ShoppingCartOutlinedIcon
            className="icon"
            style={{
              backgroundColor: "rgba(218, 165, 32, 0.2)",
              color: "goldenrod",
            }}
          />
        ),
      };
      break;
    case "earning":
      data = {
        title: "EARNINGS",
        isMoney: true,
        count: earnOrder,
        link: "View net earnings",
        anchor: "/stats",
        icon: (
          <MonetizationOnOutlinedIcon
            className="icon"
            style={{ backgroundColor: "rgba(0, 128, 0, 0.2)", color: "green" }}
          />
        ),
      };
      break;
    case "products":
      data = {
        title: "PRODUCTS",
        isMoney: false,
        count: countProducts,
        link: "See details",
        anchor: "/adminProducts",
        icon: (
          <AccountBalanceWalletOutlinedIcon
            className="icon"
            style={{
              backgroundColor: "rgba(128, 0, 128, 0.2)",
              color: "purple",
            }}
          />
        ),
      };
      break;
    default:
      break;
  }

  return (
    <div className="widget">
      <div className="left">
        <span className="title">{data.title}</span>
        <span className="counter">
          {data.isMoney && "₹"} {data.count}
        </span>
        <span className="link">
          <Link to={data.anchor}>{data.link}</Link>
        </span>
      </div>
      <div className="right">
        <div className="percentage positive">
          <KeyboardArrowUpIcon />
          {diff} %
        </div>
        {data.icon}
      </div>
    </div>
  );
};

export default Widget;
